import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { DatePipe } from '@angular/common';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BsModalService } from 'ngx-bootstrap/modal';

import { routes } from './app.routes';
import { MyHttpInterceptor } from './shared/http.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // Animations must be enabled before toastr
    provideAnimations(),
    provideToastr({
      positionClass: 'toast-top-right',
      timeOut: 3000,
      closeButton: true,
      preventDuplicates: true,
    }),
    // Needed for ngx-mask InjectionToken `ngx-mask config`
    provideEnvironmentNgxMask(),
    // ngx-bootstrap v21+: forRoot() removed — provide BsModalService directly
    BsModalService,
    // Global date format across the app (keep ngx-bootstrap default config too).
    {
      provide: BsDatepickerConfig,
      useFactory: () => {
        const cfg = new BsDatepickerConfig();
        cfg.dateInputFormat = 'MM/DD/YYYY';
        return cfg;
      },
    },
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: MyHttpInterceptor, multi: true },
  ],
};
